import c from 'classnames';
import { Component, createRef } from 'react';
import { scrollTo } from '../../../../services/Scroll';
import Button from '../../../Button';
import styles from '../style.m.less';

interface Props<T> {
    options: T[];
    selectedIndex: number | null;
    onSelect: (opt: T) => void;
    scrollToSelected?: boolean;
}

export default class Selector<T extends String> extends Component<Props<T>> {
    constructor(props: Props<T>) {
        super(props);
        this.ref = createRef();
    }

    static defaultProps: Partial<Props<String>> = {
        scrollToSelected: true,
    };

    componentDidMount() {
        if (this.props.scrollToSelected) {
            this.scrollToSelected(0);
        }
    }

    componentDidUpdate(prevProps: Props<T>) {
        const { selectedIndex, scrollToSelected } = this.props;

        if (prevProps.selectedIndex !== selectedIndex && scrollToSelected) {
            this.scrollToSelected(200);
        }
    }

    ref = createRef<HTMLDivElement>();

    // See: https://github.com/react-component/time-picker/blob/a3d956df594ad81525321bbeffe247341034a46f/src/Select.jsx
    scrollToSelected = (duration: number) => {
        const { selectedIndex } = this.props;
        const list = this.ref.current;

        if (selectedIndex === null || !list) {
            return;
        }
        let index = selectedIndex;
        if (index < 0) {
            index = 0;
        }
        const topOption = list.children[index] as HTMLElement;
        if (topOption) {
            const to = topOption.offsetTop;
            scrollTo(list, to, duration);
        }
    };

    render() {
        const { options, selectedIndex, onSelect } = this.props;
        return (
            <div className={styles.selector} ref={this.ref}>
                {options.map((opt, idx) => (
                    <Button
                        kind="TRANSPARENT"
                        onClick={() => onSelect(opt)}
                        key={opt.toString()}
                        className={c(styles.item, {
                            [styles.selectedItem]: selectedIndex === idx,
                        })}
                        type="button"
                        tabIndex={-1}
                    >
                        {opt}
                    </Button>
                ))}
            </div>
        );
    }
}
